export const SET_SUBSCRIPTIONS = (state, payload) => {
    state.subscriptionInfo = payload
}
export const SET_BANK_ACCOUNTS = (state, payload) => {
    state.bankAccounts = payload
}